import { createUseServiceInfiniteQueryHook } from './createUseServiceInfiniteQueryHook';

export const useHotelSearchResults = createUseServiceInfiniteQueryHook(
    'get_hotel_search_results',
    { refetchOnWindowFocus: false },
);
